// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2KY5P","notes":"Notes_notes__blXzQ","note":"Notes_note__da6O9","markdown":"Notes_markdown__bUzlN"};